"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/web.dom.iterable");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.sort");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _loading = require("@/mixins/loading/loading");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _theme = require("@/mixins/theme/theme");

var _elementUi = require("element-ui");

var _countdown = _interopRequireDefault(require("@/components/countdown/countdown.vue"));

var _numberCount = _interopRequireDefault(require("@/components/number-count/number-count.vue"));

var _gaugeChart = _interopRequireDefault(require("@/components/gauge-chart/gauge-chart.vue"));

var _moment = _interopRequireDefault(require("moment"));

var _summaryDashboard = require("./summary-dashboard.constants");

var _report = require("@/api/report.api");

var _permission = require("@/mixins/permission/permission");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRSummaryDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRSummaryDashboardComponent, _Mixins);

  var _super = _createSuper(MRSummaryDashboardComponent);

  function MRSummaryDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRSummaryDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.DEFAULT_ATTRIBUTES = _summaryDashboard.DEFAULT_ATTRIBUTES;
    _this.reportAPI = null;
    _this.masks = {
      weekdays: 'WWW'
    };
    _this.attributes = [{
      key: 'today',
      customData: {
        isShow: false,
        title: '',
        class: ''
      },
      dates: new Date()
    }];
    _this.calendarData = [];
    _this.datePlanData = null;
    _this.summaryData = [];
    _this.refreshTime = 30; // seconds

    _this.month = (0, _moment.default)(new Date()).format('YYYY-MM');
    _this.isShowDateModal = false;
    return _this;
  }

  (0, _createClass2.default)(MRSummaryDashboardComponent, [{
    key: "estimatedDistance",
    get: function get() {
      return Math.round(this.helper.get(this.summaryData, 'estimatedDistance', 0) / 1000);
    }
  }, {
    key: "estimatedTime",
    get: function get() {
      var time = this.helper.get(this.summaryData, 'estimatedTime', 0);
      return this.helper.secondsToHms(time);
    }
  }, {
    key: "onTimePercentage",
    get: function get() {
      var onTime = this.helper.get(this.summaryData, 'onTimeCount', 0);
      var late = this.helper.get(this.summaryData, 'notOnTimeCount', 0);
      var total = onTime + late;

      if (total === 0) {
        return 0;
      }

      return parseFloat((100 * onTime / (onTime + late)).toFixed(2));
    }
  }, {
    key: "summaryTableData",
    get: function get() {
      var data = this.helper.get(this.summaryData, 'performance', []);

      if (data.length === 0) {
        return [];
      }

      data = data // .filter(driver => !this.helper.isUndefined(driver.driverId))
      .sort(function (a, b) {
        var total1 = a.onTimeCount + a.notOnTimeCount;
        var percentage1 = total1 === 0 ? 0 : 100 * a.onTimeCount / total1;
        var total2 = b.onTimeCount + b.notOnTimeCount;
        var percentage2 = total2 === 0 ? 0 : 100 * b.onTimeCount / total2;
        return percentage2 - percentage1;
      });
      return data;
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {}
  }, {
    key: "created",
    value: function created() {
      this.refreshTime = parseInt(this.helper.get(this.$userSetting, 'default14', 30), 10);

      if (!this.reportAPI) {
        this.reportAPI = new _report.ReportAPI({
          customerKey: this.$userInformation.customerKey || ''
        });
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var countdownEl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                countdownEl = this.helper.get(this.$refs, 'countdown', null);

                if (!countdownEl) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this.getData();

              case 4:
                countdownEl.startTimer();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }() // hacked should use socket

  }, {
    key: "handleCountdownZero",
    value: function () {
      var _handleCountdownZero = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getData();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleCountdownZero() {
        return _handleCountdownZero.apply(this, arguments);
      }

      return handleCountdownZero;
    }()
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.reportAPI.getMRSummaryDashboard({
                  month: this.month
                });

              case 2:
                res = _context3.sent;

                if (!(!res || res.failed)) {
                  _context3.next = 6;
                  break;
                }

                this.resetData();
                return _context3.abrupt("return", false);

              case 6:
                this.summaryData = this.helper.cloneDeep(this.helper.get(res, 'data', []));
                this.getCalendarData(this.summaryData['date']);
                this.logger.info('Summary Dashboard', this.summaryData);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "handleMonthChanges",
    value: function () {
      var _handleMonthChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(newVal) {
        var calendarEl;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                calendarEl = this.helper.get(this.$refs, 'calendar', null);

                if (calendarEl) {
                  calendarEl.move(newVal);
                }

                _context4.next = 4;
                return this.getData();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleMonthChanges(_x) {
        return _handleMonthChanges.apply(this, arguments);
      }

      return handleMonthChanges;
    }()
  }, {
    key: "formatOnTimePercentage",
    value: function formatOnTimePercentage(data) {
      var onTime = this.helper.get(data, 'onTimeCount', 0);
      var late = this.helper.get(data, 'notOnTimeCount', 0);
      var total = onTime + late;

      if (total === 0) {
        return 0;
      }

      return parseFloat((100 * onTime / total).toFixed(2));
    }
  }, {
    key: "getCalendarData",
    value: function getCalendarData(data) {
      var _this2 = this;

      if (this.helper.isUndefined(data) || data.length === 0) {
        return;
      }

      this.calendarData = data;
      var lateData = [];
      var attributes = [{
        key: 'lessTrucks',
        customData: {
          isShow: false,
          title: '',
          class: ''
        },
        bar: {
          color: 'blue'
        },
        dates: []
      }, {
        key: 'moreTrucks',
        customData: {
          isShow: false,
          title: '',
          class: ''
        },
        bar: {
          color: 'indigo'
        },
        dates: []
      }, {
        key: 'lessOnTime',
        customData: {
          isShow: false,
          title: '',
          class: ''
        },
        bar: {
          color: 'red'
        },
        dates: []
      }, {
        key: 'moreOnTime',
        customData: {
          isShow: false,
          title: '',
          class: ''
        },
        bar: {
          color: 'green'
        },
        dates: []
      }, {
        key: 'noCompletedWaypoints',
        customData: {
          isShow: false,
          title: '',
          class: ''
        },
        bar: {
          color: 'gray'
        },
        dates: []
      }];
      data.forEach(function (val, index) {
        if (_this2.hasMoreTrucks(val['truckId'].length)) {
          attributes[1]['dates'].push(val['date']);
        } else {
          attributes[0]['dates'].push(val['date']);
        }

        var hasCompletedOrders = _this2.hasCompletedOrders(val);

        var hasMoreOnTimeWaypoints = _this2.hasMoreOnTimeWaypoints(val);

        if (!hasCompletedOrders) {
          attributes[4]['dates'].push(val['date']);
        } else {
          if (hasMoreOnTimeWaypoints) {
            attributes[3]['dates'].push(val['date']);
          } else {
            attributes[2]['dates'].push(val['date']);
          }

          var formattedEstimateReason = _this2.formatLateReason(val['estimateReason']);

          if (formattedEstimateReason.length > 0) {
            formattedEstimateReason.forEach(function (reason, i) {
              lateData.push({
                key: "".concat(i, "-estimate-late-").concat(val['date']),
                customData: {
                  isShow: true,
                  title: "".concat(_this2.$i18n.t('planning.etaDiscrepancyReason'), " = ").concat(reason),
                  class: "bg-yellow-600 text-white"
                },
                dates: val['date']
              });
            });
          }

          var formattedEndReason = _this2.formatLateReason(val['endReason']);

          if (formattedEndReason.length > 0) {
            formattedEndReason.forEach(function (reason, i) {
              lateData.push({
                key: "".concat(i, "-end-late-").concat(val['date']),
                customData: {
                  isShow: true,
                  title: "".concat(_this2.$i18n.t('planning.endTimeDiscrepancyReason'), " = ").concat(reason),
                  class: "bg-orange-600 text-white"
                },
                dates: val['date']
              });
            });
          }
        }
      });
      this.attributes = this.helper.cloneDeep([].concat((0, _toConsumableArray2.default)(this.attributes), attributes, lateData));
    }
  }, {
    key: "hasMoreTrucks",
    value: function hasMoreTrucks(truckLen) {
      var totalTruckLen = this.$trucks.length;

      if (totalTruckLen === 0) {
        return false;
      }

      return truckLen / totalTruckLen >= 0.25;
    }
  }, {
    key: "hasCompletedOrders",
    value: function hasCompletedOrders(plan) {
      return this.helper.get(plan, 'completedWaypoints', 0);
    }
  }, {
    key: "hasMoreOnTimeWaypoints",
    value: function hasMoreOnTimeWaypoints(plan) {
      var onTime = this.helper.get(plan, 'onTimeCount', 0);
      var late = this.helper.get(plan, 'notOnTimeCount', 0);
      var total = onTime + late;

      if (total === 0) {
        return false;
      }

      return onTime / total >= 0.5;
    }
  }, {
    key: "handleDateClicked",
    value: function handleDateClicked(dateData) {
      var date = dateData['id'];
      var datePlanObj = this.calendarData.find(function (d) {
        return d['date'] === date;
      });

      if (!this.helper.isUndefined(datePlanObj)) {
        this.datePlanData = datePlanObj;
        this.isShowDateModal = true;
      }
    }
  }, {
    key: "getDateClass",
    value: function getDateClass(dateData) {
      var date = dateData['id'];
      var datePlanObj = this.calendarData.find(function (d) {
        return d['date'] === date;
      });
      var isToday = date === (0, _moment.default)(new Date()).format('YYYY-MM-DD');
      return {
        'cursor-pointer': !this.helper.isUndefined(datePlanObj),
        'today': isToday
      };
    }
  }, {
    key: "goToPlan",
    value: function goToPlan(date) {
      this.isShowDateModal = false;
      this.$router.push({
        name: 'mrManualAssign',
        query: {
          date: date
        }
      });
    }
  }, {
    key: "resetData",
    value: function resetData() {
      this.calendarData = [];
      this.datePlanData = null;
      this.summaryData = [];
    }
  }, {
    key: "formatLateReason",
    value: function formatLateReason(data) {
      return data.filter(function (reason) {
        return reason !== 'ontime' && reason !== 'on time' && reason !== '-';
      });
    }
  }]);
  return MRSummaryDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _milkRun.MilkRunMixin, _theme.ThemeMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MRSummaryDashboardComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], MRSummaryDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MRSummaryDashboardComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRSummaryDashboardComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('projectCodes', {
  namespace: 'common'
})], MRSummaryDashboardComponent.prototype, "$projectCodes", void 0);
MRSummaryDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRSummaryDashboardComponent',
  components: {
    'countdown': _countdown.default,
    'number-count': _numberCount.default,
    'gauge-chart': _gaugeChart.default,
    'el-date-picker': _elementUi.DatePicker,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-card': _elementUi.Card,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-dialog': _elementUi.Dialog
  }
})], MRSummaryDashboardComponent);
var _default = MRSummaryDashboardComponent;
exports.default = _default;